import SmallScreenHeader from "../../containers/SmallScreenHeader";

const Facets = () => (
  <>
    <SmallScreenHeader />
  </>
);

export default Facets;
